import React, { useState, useEffect } from "react";
import { fetchtenderapi } from "../api/fetchtenderapi";
import { BASE_API } from "../Config/Config";
import { DatePicker, Button } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

function Tenders() {
  const [bulletins, setBulletins] = useState([]);
  const [allTenders, setAllTenders] = useState([]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  const { t, i18n } = useTranslation();

  const loadTenders = async () => {
    setLoading(true);
    const data = await fetchtenderapi();
    setBulletins(data);
    setLoading(false);
  };

  useEffect(() => {
    loadTenders();
  }, []);

  // const handleDownload = async (filename) => {
  //   if (!filename) return;

  //   try {
  //     const url = `${BASE_API}/apis/uploads/tenders/${filename}`;

  //     const response = await fetch(url);

  //     if (!response.ok) {
  //       throw new Error("Failed to download file");
  //     }

  //     const blob = await response.blob();

  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.download = filename;

  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();

  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //   }
  // };

  const filterTenders = () => {
    if (!fromDate && !toDate) {
      setBulletins(allTenders);
      return;
    }

    const from = fromDate ? new Date(fromDate + "-01") : null;

    const to = toDate
      ? new Date(new Date(toDate + "-01").getFullYear(), new Date(toDate + "-01").getMonth() + 1, 0)
      : null;

    const filtered = allTenders.filter((item) => {
      const itemDate = new Date(item.start_date);
      if (from && itemDate < from) return false;
      if (to && itemDate > to) return false;
      return true;
    });

    setBulletins(filtered);
  };

  const handleDownload = async (tender) => {
    if (!tender?.id || !tender?.doc) {
      Swal.fire({
        icon: "warning",
        title: "No Document",
        text: "Document is not available."
      });
      return;
    }

    let objectUrl = null;

    try {
      const response = await fetch(
        `${BASE_API}/apis/PreviewDoc.php?id=${encodeURIComponent(tender.id)}`,
        {
          method: "GET"
        }
      );

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error("Published document not found.");
        }

        throw new Error("Unable to retrieve document.");
      }

      const file = await response.blob();

      if (file.type !== "application/pdf") {
        throw new Error("The requested document is not a valid PDF.");
      }

      objectUrl = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.target = "_blank";
      link.rel = "noopener noreferrer";

      document.body.appendChild(link);
      link.click();
      link.remove();

      // Release the temporary URL after the browser has had time to open it
      setTimeout(() => {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        }
      }, 60000);

    } catch (error) {
      console.error("Home document preview error:", error);

      Swal.fire({
        icon: "error",
        title: "Preview Failed",
        text: error.message || "Unable to open document."
      });
    }
  };

  useEffect(() => {
    const loadTenders = async () => {
      setLoading(true);
      const data = await fetchtenderapi();
      setAllTenders(data);
      setBulletins(data);
      setLoading(false);
    };

    loadTenders();
  }, []);

  return (
    <div className="container my-5">
      <div className="card shadow-sm border-0 rounded-4 p-4">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
          <h3 className="fw-bold text-uppercase text-primary">
            {t("tenderNotices")}
          </h3>

          {/* Date Filter */}
          <div className="d-flex align-items-center gap-3 flex-wrap">
            {/* From Month */}
            <div className="d-flex align-items-center gap-2">
              <label className="fw-semibold">{t("from")}</label>
              <DatePicker
                picker="month"
                className="form-control"
                placeholder={t("selectMonth")}
                value={fromDate ? dayjs(fromDate, "YYYY-MM") : null}
                onChange={(date, dateString) => setFromDate(dateString)}
                format="YYYY-MM"
              />
            </div>

            {/* To Month */}
            <div className="d-flex align-items-center gap-2">
              <label className="fw-semibold">{t("to")}</label>
              <DatePicker
                picker="month"
                className="form-control"
                placeholder={t("selectMonth")}
                value={toDate ? dayjs(toDate, "YYYY-MM") : null}
                onChange={(date, dateString) => setToDate(dateString)}
                format="YYYY-MM"
              />
            </div>

            {/* Search Button */}
            <Button type="primary" onClick={filterTenders}>
              {t("search")}
            </Button>

            {/* Optional Reset Button */}
            <Button onClick={() => {
              setFromDate("");
              setToDate("");
              setBulletins(allTenders);
            }}>
              {t("reset")}
            </Button>
          </div>
        </div>

        <hr />

        {/* Bulletin List */}
        {loading ? (
          <div className="text-center my-5">Loading...</div>
        ) : bulletins.length === 0 ? (
          <div className="text-center my-5">{t("noTendersFound")}</div>
        ) : (
          <div className="row g-4 mt-2">
            {bulletins.map((item) => (
              <div
                key={item.id}
                className="col-md-12"
              >
                <div className="border rounded-3 p-3 d-flex justify-content-between align-items-center shadow-sm bg-light hover-card">
                  <span className="fw-semibold">
                    {i18n.language === "ta" ? item.tender_name_ta : item.tender_name_en || t("tender")} - {item.start_date}
                  </span>

                  <Button
                    onClick={() => handleDownload(item)}
                    disabled={!item?.doc}
                    className="btn btn-sm btn-info"
                  >
                    <i className="bi bi-eye me-1"></i>
                    View Document
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

export default Tenders;